import './index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router.js'
import App from './App.vue'
import registerDirectives from './directives'
import registerPlugins from './plugins'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)
registerPlugins(app)
registerDirectives(app)

app.mount('#app')
